/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonAttachmentItemViewModel } from "../types/PersonAttachmentItemViewModel.ts";
import { eDocumentationStatusSchema } from "./eDocumentationStatusSchema.ts";

export const personAttachmentItemViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do anexo da pessoa.")),
  personId: z.optional(
    z.number().int().describe("ID da pessoa à qual o anexo pertence."),
  ),
  fileName: z.string().describe("Nome do arquivo anexado.").nullish(),
  documentTypeName: z
    .string()
    .describe("Nome do tipo de documento do anexo.")
    .nullish(),
  enrollmentDocumentId: z
    .number()
    .int()
    .describe("ID do documento de matrícula associado ao anexo. Opcional.")
    .nullish(),
  documentationStatus: z.optional(
    z
      .lazy(() => eDocumentationStatusSchema)
      .describe(
        "0 = Pending | 1 = Approved | 2 = Rejected | 3 = ApprovedTemporary | ",
      ),
  ),
  statusName: z
    .string()
    .describe("Nome legível do status de documentação do anexo.")
    .nullish(),
  creationDate: z
    .string()
    .datetime()
    .describe("Data de criação do anexo. Opcional.")
    .nullish(),
  active: z.optional(z.boolean().describe("Indica se o anexo está ativo.")),
  reasonName: z
    .string()
    .describe(
      "Nome do motivo associado ao status do anexo (ex: motivo de rejeição). Opcional.",
    )
    .nullish(),
  isPdf: z.optional(
    z.boolean().describe("Indica se o arquivo anexado é um PDF."),
  ),
}) as unknown as ToZod<PersonAttachmentItemViewModel>;
